/** Баннер на read-only экранах справочников для CITY_MODERATOR. */
export function SuperadminCatalogNotice() {
  return (
    <div
      role="status"
      className="mb-6 rounded-md border border-border bg-muted/40 px-4 py-3 text-sm text-muted-foreground"
    >
      <p className="font-medium text-foreground">Только просмотр</p>
      <p className="mt-1">
        Редактировать этот раздел может только SUPERADMIN. Вы видите актуальные данные справочника.
      </p>
    </div>
  );
}
